module.exports = __webpack_public_path__ + "static/media/60.1d7dfa7a.png";